import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(
    pictures: string[],
    id_room: string,
    id_object: string,
  ) {
    const requestBody = {
      id_object,
      id_room,
      pictures: pictures.map(p => p.split(',')[1]),
    }
    const response = await api.fetch(`/api/v2/pictures/index`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    return await handleResponse(response)
  }
}
